/**
 * 工具函数集合
 * 用于 positions-panel 相关组件的数据处理
 */

/**
 * 安全地将任意值转换为数字
 *
 * @param value - 待转换的值
 * @param fallback - 转换失败时的默认值，默认为 0
 * @returns 转换后的数字或默认值
 */
export const toNumber = ( value: any, fallback = 0 ) => {
    const parsed = Number( value );
    return Number.isFinite( parsed ) ? parsed : fallback;
};

/**
 * 格式化时间戳为可读的日期时间字符串
 *
 * @param value - 时间戳（毫秒）
 * @returns 格式化后的时间字符串，如 "Jan 12, 2024, 03:45 PM"，无效值返回 "-"
 */
export const formatTime = ( value: any ) => {
    if ( value === null || value === undefined || value === "" ) return "-";
    const numeric = Number( value );
    if ( Number.isFinite( numeric ) && numeric > 0 ) {
        const timestamp = numeric < 1_000_000_000_000 ? numeric * 1000 : numeric;
        return new Date( timestamp ).toLocaleString( "en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        } );
    }
    return String( value );
};
